import { render, staticRenderFns } from "./TransferCall.vue?vue&type=template&id=578df678&scoped=true"
import script from "./TransferCall.vue?vue&type=script&lang=js"
export * from "./TransferCall.vue?vue&type=script&lang=js"
import style0 from "./TransferCall.vue?vue&type=style&index=0&id=578df678&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578df678",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578df678')) {
      api.createRecord('578df678', component.options)
    } else {
      api.reload('578df678', component.options)
    }
    module.hot.accept("./TransferCall.vue?vue&type=template&id=578df678&scoped=true", function () {
      api.rerender('578df678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/conversations/TransferCall.vue"
export default component.exports